import { useState } from 'react';

const projects = [
  {
    image: 'https://public.readdy.ai/ai/img_res/01e69b3f1e4558362b45e409786d9245.jpg',
    title: 'Marca de Belleza',
    type: 'Gestión de Instagram',
    height: 'tall',
    link: 'https://www.instagram.com/paty_publicidad?igsh=MWN3ZWJqazA0OGR6dw%3D%3D&utm_source=qr'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Instagram%20stories%20mockup%20collection%20for%20fashion%20boutique%2C%20pink%20and%20purple%20gradient%20backgrounds%2C%20modern%20story%20templates%2C%20product%20showcase%2C%20promotional%20stories%20design%2C%20feminine%20aesthetic&width=400&height=400&seq=portfolio-2&orientation=squarish',
    title: 'Boutique de Moda',
    type: 'Stories & Reels',
    height: 'medium',
    link: ''
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Instagram%20reels%20cover%20templates%20for%20lifestyle%20brand%2C%20colorful%20vibrant%20designs%2C%20engaging%20video%20thumbnails%2C%20pink%20purple%20color%20scheme%2C%20modern%20social%20media%20graphics&width=400&height=400&seq=portfolio-3&orientation=squarish',
    title: 'Marca Lifestyle',
    type: 'Reels Creativos',
    height: 'medium',
    link: 'https://drive.google.com/file/d/1YNc7RkeqDDQ2NFhA-8GoEhJupMvHyGWM/view?usp=drive_link'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Complete%20social%20media%20campaign%20mockup%20for%20product%20launch%2C%20multiple%20platform%20designs%2C%20cohesive%20branding%2C%20pink%20and%20purple%20theme%2C%20professional%20marketing%20materials%2C%20clean%20backgrounds&width=400&height=600&seq=portfolio-4&orientation=portrait',
    title: 'Lanzamiento de Producto',
    type: 'Campaña Completa',
    height: 'tall',
    link: ''
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Social%20media%20graphic%20design%20templates%20for%20wellness%20brand%2C%20calming%20aesthetic%2C%20pink%20purple%20gradients%2C%20inspirational%20quote%20posts%2C%20modern%20minimalist%20design%2C%20clean%20backgrounds&width=400&height=400&seq=portfolio-5&orientation=squarish',
    title: 'Marca de Wellness',
    type: 'Diseño Gráfico',
    height: 'medium',
    link: 'https://www.instagram.com/batoniproducciones?igsh=eG9xM29zcDRkaW5s&utm_source=qr'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Instagram%20carousel%20post%20design%20for%20coaching%20business%2C%20educational%20content%20layout%2C%20professional%20templates%2C%20pink%20purple%20color%20palette%2C%20modern%20social%20media%20graphics%2C%20clean%20white%20background&width=400&height=400&seq=portfolio-6&orientation=squarish',
    title: 'Coach Personal',
    type: 'Contenido Educativo',
    height: 'medium',
    link: 'https://www.instagram.com/dalupenaloza?igsh=MWc4M3hscWxhbTBzbA%3D%3D&utm_source=qr'
  }
];

export default function Portfolio() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <section id="portafolio" className="py-24 bg-white relative overflow-hidden">
      {/* Patrón de fondo */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{ backgroundImage: 'linear-gradient(#FF6B9D 1px, transparent 1px), linear-gradient(90deg, #FF6B9D 1px, transparent 1px)', backgroundSize: '50px 50px' }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6">
        {/* Encabezado */}
        <div className="flex items-center justify-between mb-12">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-purple-900 mb-3">
              Proyectos que hablan por sí solos
            </h2>
            <p className="text-gray-600 text-lg">
              Resultados reales para marcas reales
            </p>
          </div>
          <div className="hidden md:block">
            <span className="px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-medium rounded-full cursor-pointer hover:shadow-lg transition-all whitespace-nowrap">
              Ver todos
            </span>
          </div>
        </div>

        {/* Grid de proyectos */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {projects.map((project, index) => {
            const ProjectWrapper = project.link ? 'a' : 'div';
            const linkProps = project.link ? {
              href: project.link,
              target: '_blank',
              rel: 'noopener noreferrer'
            } : {};

            return (
              <ProjectWrapper
                key={index}
                {...linkProps}
                className={`relative rounded-3xl overflow-hidden cursor-pointer group ${
                  project.height === 'tall' ? 'row-span-2' : ''
                }`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                {/* Imagen */}
                <div className="relative w-full h-full min-h-[300px]">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>

                {/* Overlay */}
                <div
                  className={`absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent transition-all duration-300 ${
                    hoveredIndex === index ? 'opacity-100' : 'opacity-60'
                  }`}
                ></div>

                {/* Contenido */}
                <div
                  className={`absolute bottom-0 left-0 right-0 p-6 transform transition-all duration-300 ${
                    hoveredIndex === index ? 'translate-y-0' : 'translate-y-4'
                  }`}
                >
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-3 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-medium rounded-full">
                      {project.type}
                    </span>
                  </div>
                  <div
                    className={`flex items-center gap-2 text-pink-300 transition-all duration-300 ${
                      hoveredIndex === index ? 'opacity-100' : 'opacity-0'
                    }`}
                  >
                    <span className="text-sm font-medium">Ver proyecto</span>
                    <i className="ri-arrow-right-line"></i>
                  </div>
                </div>
              </ProjectWrapper>
            );
          })}
        </div>
      </div>
    </section>
  );
}
